<template>
  <nav
    class="the-header-article fixed left-[var(--grid-bleed)] right-[var(--grid-bleed)] top-[var(--header-top-mobile)] z-[calc(var(--z-index-header)+2)] flex flex-row justify-between lg:top-[var(--header-top)]"
  >
    <!-- @click.prevent="goBack" -->
    <button
      data-cursor="empty"
      @click="goBack"
      aria-label="Go back"
      class="flex h-[40px] w-[40px] cursor-pointer justify-center rounded-corner-02-desktop border border-stroke-dark text-focus-dark backdrop-blur-[5px] lg:h-[48px] lg:w-auto lg:px-spacing-02-desktop lg:py-[20px]"
    >
      <NuxtIcon
        v-if="isMobile"
        name="chevron-right"
        class="icon h-[12px] w-[12px] rotate-180 self-center"
      ></NuxtIcon>
      <ui-font-text v-else type="label" class="flex flex-row items-center gap-[10px]">
        <NuxtIcon
          name="chevron-right"
          class="icon h-[12px] w-[12px] rotate-180 self-center"
        ></NuxtIcon>
        Back
      </ui-font-text>
    </button>
    <ui-call-to-action
      v-if="cta && !isMobile"
      data-cursor="empty"
      class="cursor-pointer justify-center rounded-corner-02-desktop bg-focus-dark text-focus-light lg:h-[48px] lg:w-auto lg:px-spacing-02-desktop lg:py-[20px]"
      :cta="cta"
      :is-article="true"
    ></ui-call-to-action>
  </nav>
</template>

<script setup>
const props = defineProps({
  cta: Object,
})
const router = useRouter()
const { isMobileOrTablet } = useDevice()
const { width: innerWidth } = useWindowSize()

const isMobile = computed(() => {
  if (process.server) return isMobileOrTablet
  return innerWidth.value < 900
})
const goBack = () => {
  if (window.history.state.back === null) {
    router.push('/')
  } else {
    router.back()
  }
}
</script>

<style>
.icon svg {
  width: 100%;
  height: 100%;
  margin-bottom: 0;
}
</style>
